
define('eteration/ui/validation-helper',['jquery',
		'eteration/eteration-i18n',
		'eteration/ui/char-utils',
		'underscore'], 
	function($,i18n,charUtils,underscore) {
	
	
	
	
	var format = function(source,params) {
		if ( arguments.length === 1 ) {
			return function() {
				var args = $.makeArray(arguments);
				args.unshift(source);
				return format.apply( this, args );
			};
		}
		if ( arguments.length > 2 && params.constructor !== Array ) {
			params = $.makeArray(arguments).slice(1);
		}
		if ( params.constructor !== Array ) {
			params = [ params ];
		}
		$.each(params, function( i, n ) {
			source = source.replace( new RegExp("\\{" + i + "\\}", "g"), function() {
				return n;
			});
		});
		return source;
	};
	

	var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/;
	var alphaNumericPasswordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8}$/;


	var isEmptyValue = function(val){
		if(val != null){
			return !$.trim(val);
		}
		return true;
	};
	
	var tcIdValidator = function(identityNumber){
		
		if (!identityNumber.match(/[1-9]{1}[0-9]{10}/)){
				return false;							
		}
		
		var Tmp1,Tmp;
		
		Tmp = parseInt(identityNumber / 100);
		Tmp1 = parseInt(identityNumber / 100);
		
		var odd_sum, even_sum, total, CheckDigit1, CheckDigit2;
		var NumArray = [];
		
		for(var i=8;i>=0; i--){
			NumArray[i]= (Tmp1 % 10);
			Tmp1 = parseInt(Tmp1 / 10);
		}
		
		odd_sum = NumArray[8] + NumArray[6] + NumArray[4] + NumArray[2] + NumArray[0];
		even_sum = NumArray[7] + NumArray[5] + NumArray[3] + NumArray[1];
		
		total = odd_sum * 3 + even_sum;

		CheckDigit1 = (10-(total % 10)) % 10;
		
		
		odd_sum = CheckDigit1 + NumArray[7] + NumArray[5] + NumArray[3] + NumArray[1];
		even_sum = NumArray[8] + NumArray[6] + NumArray[4] + NumArray[2] + NumArray[0];
		
		total = odd_sum * 3 + even_sum;

		CheckDigit2 = (10-(total % 10)) % 10;
		
		Tmp = Tmp * 100 + CheckDigit1 * 10 + CheckDigit2;
		
		if(Tmp != identityNumber){
			return false;
		}
		
		return true;
	}
	
	var milesSmilesValidator = function(milesSmilesNo){

		if (!milesSmilesNo.match(/[0-9]{9}/)){
			return false;
		}

		var arrayLength = milesSmilesNo.length;
		var total = 0;
		for (var i = 0; i < arrayLength-1; i++) {
			total = total + milesSmilesNo[i];
		}

		total = total - milesSmilesNo[arrayLength-1];
		var resultMod = total % 9;

		if(resultMod != 0)
			return false;

		return true;

	}
	
	var validTCKNO = function(tcId){
		var isValid = tcIdValidator(tcId);
		if (!isValid)
			return i18n.get('Error-OB-50'); 
	}
	
	var isValidDateLabel = function(dates,singleDate){
		if(singleDate){
			if(dates.length==0)
				return false;
		}else{
			if(dates.length!=2)
				return false;
		}
		return true;
	};
	
	var validators = {
		"email" : function(el) {
				if(!emailRegex.test($(el).val()))
					return i18n.get("Error-CNV-1005");
		},

		"alphaNumericPassword" : function(el) {
			if(!alphaNumericPasswordPattern.test($(el).val()))
				return i18n.get("ERR-MS-LOGIN-35");
		}, 
		
		"required" : function(el,msg) {
			function isEmpty( el ){
				return !$.trim($(el).val());
			}
					
			var e = $(el);
			
			if(e.is("input")){
				if(isEmpty(el)){
					if(msg)
						return i18n.get(msg);
					else
						return i18n.get("ERR-MS-LOGIN-380");
				}
			}else	if(e.is("select")){
				
				var id = e.attr('id');
				var index = $('#'+id+' option:selected').index();
				if(isEmpty(el) && index == 0){
					if(msg)
						return i18n.get(msg);
					else
						return i18n.get("ERR-MS-LOGIN-380");
				}
			}
						
		},
		
		"rangelength" : function(el,dv) {
			
			var range = dv.range;
			var msg = dv.rangelengthMsg;
			var val = $(el).val().length;
			if(!msg){
				msg = "error.value.notInRange";
			}
			if(val<range[0] || val>range[1]){
				return format(i18n.get(msg),range[0],range[1]);
			}
		},
		
		"exactlength" : function(el,dv) {
			
			var exactlength = dv.exactlength;
			var msg = dv.exactlengthMsg;
			var val = $(el).val().length;
			if(!msg){
				msg = "##** please define 'exactlengthMsg' parameter look like \"exactlengthMsg\":\"ERR-MS-LOGIN-1002\" **##";
			}
			if(val != exactlength){
				return format(i18n.get(msg),exactlength);
			}
		},
		
		"minlength" : function(el,dv) {
				
			var minlength = dv.minlength;
			var minlengthMsg = dv.minlengthMsg || "##** please define 'minlengthMsg' parameter look like \"minlengthMsg\":\"ERR-MS-LOGIN-1002\" **##";
			var validateBlankInput = underscore.isBoolean(dv.validateBlankInput) ? dv.validateBlankInput : true;
			var length = $(el).val().length || $(el).text().length || 0;
			
			if(length && (length < minlength)){
				return format(i18n.get(minlengthMsg),minlength);
			}
			
			if(validateBlankInput && !length){
				return format(i18n.get(minlengthMsg),minlength);
			}
			
		},

		"maxlength" : function(el,dv) {

			var maxlength = dv.maxlength;
			var maxlengthMsg = dv.maxlengthMsg || "##** please define 'maxlengthMsg' parameter look like \"maxlengthMsg\":\"ERR-MS-LOGIN-1002\" **##";
			var validateBlankInput = underscore.isBoolean(dv.validateBlankInput) ? dv.validateBlankInput : true;
			var length = $(el).val().length || $(el).text().length || 0;

			if(length && (length > maxlength)){
				return format(i18n.get(maxlengthMsg),maxlength);
			}

			if(validateBlankInput && !length){
				return format(i18n.get(maxlengthMsg),maxlength);
			}

		},
		
		"address" : function(el,dv) {
				
				var minlength = dv.address;
				var minlengthMsg = i18n.get("ERR-MS-LOGIN-1000");
				var validateBlankInput = underscore.isBoolean(dv.validateBlankInput) ? dv.validateBlankInput : true;
				var length = $(el).val().length || $(el).text().length || 0;
				
				if(length && (length < minlength)){
					return format(i18n.get(minlengthMsg),minlength);
				}
				
				if(validateBlankInput && !length){
					return format(i18n.get(minlengthMsg),minlength);
				}
		},
		"tkminlength" : function(el,dv) {
				
			var minlength = dv.minlength;
			var length = $(el).val().length || $(el).text().length || 0;
			if(length < minlength){
				return format(i18n.get("ERR-MS-MILES-6539"),minlength);
			}
		},
		"radioMin" : function(el,_dv) {
				
			if($('#' +el.id+' input:checked').length==0)
				return format(i18n.get("error.selection.required"),1);
		},	
		
		"beforeDate" : function(el,dv) {
				var result = undefined;
				var dateDiffUnit = dv.dateDiffUnit || 'years';
				var dateDiff = dv.dateDiff;
				var limit = moment().subtract(dateDiffUnit, dateDiff);
				var val = $(el).val();
				if(moment(limit).isBefore(val))
					result = format(i18n.get("error.date.before"),limit.format('DD/MM/YYYY'));
				return result;
		},
		
		"afterDate" : function(el,dv) {
				var result = undefined;
				var dateDiffUnit = dv.dateDiffUnit || 'years';
				var dateDiff = dv.dateDiff;
				var limit = moment().subtract(dateDiffUnit, dateDiff);
				var val = $(el).val();
				if(moment(limit).isAfter(val))
					result = format(i18n.get("error.date.after"),limit.format('DD/MM/YYYY'));
				return result;
		},
		
		"latinAndTurkishChar" : function(el,_dv) {
				var result = undefined;
				
				var characters = $(el).val();
				
				if (characters && characters.length) {
					
					
					for (var characterIndex = 0; characterIndex < characters.length; characterIndex++) {
						
						var code = characters.charCodeAt(characterIndex);
						var shiftKey = false;
						var altKey = false;
						
						var codeValid = charUtils.isCodeValid(code, shiftKey, altKey,charUtils.validators, ["latin-alphabet","turkish-special-characters","space"]);
						
						if(!codeValid){
							result = i18n.get("Error-OB-36");
						}
						
					}
					
				}
				
			
				return result;
		} ,
		
		"paymentCityValidator" : function(el,_dv) {
				var result = undefined;
				
				var characters = $(el).val();
				
				if (characters && characters.length) {
					
					
					for (var characterIndex = 0; characterIndex < characters.length; characterIndex++) {
						
						var code = characters.charCodeAt(characterIndex);
						var shiftKey = false;
						var altKey = false;
						
						var codeValid = charUtils.isCodeValid(code, shiftKey, altKey,charUtils.validators, ["latin-alphabet","turkish-special-characters","space","dot","quote","comma","slash","colon","dash","semicolon","right-round-bracket","left-round-bracket","ampersand","octothorpe"]);
						
						if(!codeValid){
							result = i18n.get("Error-OB-36");
						}
						
					}
					
				}
				
			
				return result;
		} ,
		"paymentTaxValidator" : function(el,_dv) {
			var result = undefined;

			var characters = $(el).val();

			if (characters && characters.length) {


				for (var characterIndex = 0; characterIndex < characters.length; characterIndex++) {

					var code = characters.charCodeAt(characterIndex);
					var shiftKey = false;
					var altKey = false;

					var codeValid = charUtils.isCodeValid(code, shiftKey, altKey,charUtils.validators, ["numbers"]);

					if(!codeValid){
						result = i18n.get("Error-OB-36");
					}

				}

			}


			return result;
		} ,
		"paymentAddressLineValidator" : function(el,_dv) {
				var result = undefined;
				
				var characters = $(el).val();
				
				if (characters && characters.length) {
					
					
					for (var characterIndex = 0; characterIndex < characters.length; characterIndex++) {
						
						var code = characters.charCodeAt(characterIndex);
						var shiftKey = false;
						var altKey = false;
						
						var codeValid = charUtils.isCodeValid(code, shiftKey, altKey,charUtils.validators, ["latin-alphabet","turkish-special-characters","numbers","space","dot","quote","comma","slash","colon","dash","semicolon","right-round-bracket","left-round-bracket","ampersand","octothorpe"]);
						
						if(!codeValid){
							result = i18n.get("Error-OB-36");
						}
						
					}
					
				}
				
			
				return result;
		} ,
		"vehicleAddressValidator" : function(el,_dv) {
				var result = undefined;
				
				var characters = $(el).val();
				
				if (characters && characters.length) {
					
					
					for (var characterIndex = 0; characterIndex < characters.length; characterIndex++) {
						
						var code = characters.charCodeAt(characterIndex);
						var shiftKey = false;
						var altKey = false;
						
						var codeValid = charUtils.isCodeValid(code, shiftKey, altKey,charUtils.validators, ["latin-alphabet","numbers","space","dot","comma","slash","dash","semicolon","right-round-bracket","left-round-bracket"]);
						
						if(!codeValid){
							result = i18n.get("Error-OB-36");
						}
						
					}
					
				}
				
			
				return result;
		},
		"pnrNoValidator" : function(el,dv) {
			var minlength = dv.minlength;
			
			var length = $(el).val().length || $(el).text().length || 0;
			
			if(length < minlength){
				return i18n.get("Error-REZ-LOGIN-1");
			}
			
			if(minlength < length && length < 13 ){
				return i18n.get("Error-REZ-LOGIN-2");
			}		
		},
		"ticketNumberValidator" : function(el) {
 			var value = $(el).val();
			var length = value.length || $(el).text().length || 0;
			if( length != 13 || isNaN(value)){
				return i18n.get("Error-REZ-LOGIN-3");
			}
		},
		"tcIdentityValidator" : function(el,_dv) {
			var identity = $(el).val();
			
			var isValid = tcIdValidator(identity);
			if(!isValid){
				
				return i18n.get("Error-OB-50");						
			}	
		},
		"milesSmilesNoValidator" : function(el,_dv) {
			var milesSmiles = $(el).val();
			var isValid = milesSmilesValidator(milesSmiles);
			if(!isValid){
				return i18n.get("Error-ODULB-15");
			}
		},
		"tkPNRNoValidator" : function(el,dv) {
			var minlength = dv.minlength;
			
			var length = $(el).val().length || $(el).text().length || 0;
			
			if(length < minlength){
				return i18n.get("Error.pnr.length");
			}
			if(length != 0 && 0 > "RSTUVWrstuvw".indexOf($(el).val().charAt(0))){
				return i18n.get("Error.pnr.nottk");
			}
		}
	};
	
	var showServerErrors = function(errors,idMap) {
		for (var i = 0; i < errors.length; i++) {
			var error = errors[i];
			var id = idMap[error.field];
			if(id == undefined) {
				id = error.field;
			}
			var el = $("#"+id)[0];
			showError(el, i18n.get(error.msg));
		}
		
		/*** scroll to server side validation error ***/
		setTimeout(function(){
			scrollToEl($('.has-error').first(), undefined, 30, undefined, undefined, 1000);
		}, 100);

		/*** remove disable class on button which has onclickdisable class after server side validation errors ***/
		$('.onclickdisable').removeClass('disabled');
		
	};
	
	var showClientErrors = function(errors) {
		for (var i = 0; i < errors.length; i++) {
			var error = errors[i];
			showError(error.el,error.error);
		}
	};
	
	var showHeaderError = function(msg){
		
		
		var msgs = [msg];
		showHeaderErrors(msgs);
	};
	
	var removeHeaderErrors = function() {
		var close = $('header .navbar .notice button');
		if (close && close.length>0) {
			close.click();
		}
	};
	
	var showHeaderErrors = function(msgs){
		var html = '<div role="alert" class="notice notice-blue-base"><h4></h4>';
		var msgItemCodes = [];

		for (var i = 0; i < msgs.length; i++) {
			msgItemCodes.push(msgs[i].code);
		}
		msgItemCodes = underscore.uniq(msgItemCodes);

		for (var i = 0; i < msgItemCodes.length; i++) {
			var msgItem = msgItemCodes[i];
			if(msgItem.code) {
				msgItem = msgItem.code;
			}
			html +=	'<p>'+i18n.get(msgItem)+'</p>';
		}

		html += '<button class="close" type="button">×</button>'+
				'</div>';
		
		$("#errorContent").html(html);
		
		if ( $('header .navbar div').hasClass('notice') ) {
			$('header .navbar .notice button').click(function(){
				$(this).remove();
				$('header .navbar .notice').slideUp('slow',function(){ $(this).remove(); });
			});
		}

	};
	
	var showMessages = function(msgs){
		
		
		var html = '<div role="alert" class="notice notice-blue-base"><h4></h4>';
		
		for (var i = 0; i < msgs.length; i++) {
			var msg = i18n.get(msgs[i].code);
			if(msg == msgs[i].code)
				msg = msgs[i].msg
			html +=	'<p>'+msg+'</p>';
		}
		
		html += '<button class="close" type="button">×</button>'+
				'</div>';
		
		$("#errorContent").html(html);
		
		if ( $('header .navbar div').hasClass('notice') ) {
			$('header .navbar .notice button').click(function(){
				$(this).remove();
				$('header .navbar .notice').slideUp('slow',function(){ $(this).remove(); });
			});
		}

	};
	
	var removeError = function(el) {
		
		var errorBox = $('#error'+el.id);
		if(errorBox){ 
			errorBox.remove();
			$(el).removeClass("error has-error");
		}
		
		if($(el).hasClass('dropdownselect') ){
			$(el).parent().removeClass('has-feedback has-error');
			$(el).removeClass("error has-error");
		}
		
		if($(el).hasClass('uicombodate') ){
			$(el).parent().removeClass('has-feedback has-error');
		}
		
		if($(el).parent().hasClass('input-group validation-icon') ){
			$(el).parent().removeClass('has-feedback has-error');
			$(el).parent().find('.input-group-addon.validation').removeClass('has-error');
			$(el).parent().find('.input-group-addon.validation').html('<i class="fa fa-check gray"></i>');
		}
		
	};
	
	var showValidationSuccesIcon = function(el) {
		if($(el).parent().hasClass('input-group validation-icon') ){
			$(el).parent().find('.input-group-addon.validation').html('<i class="fa fa-check green"></i>');
		}
	};
	
	var showError = function(el,error) {
		var errorBox = el ? $('#error' + el.id) : false;
		if(errorBox){ 
			errorBox.remove();
			$(el).removeClass("error");
		}
		
		var errSpanClass = "";
		if($(el).parent()[0].id == 'check-in-inp1' || $(el).parent()[0].id == 'check-in-inp2') {
			errSpanClass = "class=\"fw700 white fs-14\"";
		}
		var err = '<span id="errormessage" ' + errSpanClass + '>'+error+'</span>';
		
		if ( $(el).parent().hasClass('input-group validation-icon') ) {
			var validationFailIcon = '<i class="fa fa-warning red"></i>';
			$(el).parent().find('.input-group-addon.validation').addClass('has-error');
			$(el).parent().find('.input-group-addon.validation').html(validationFailIcon);
			$(errorMSG).insertAfter($(el).parent());
		}
		
		if(el.id=="promocode")
			err = '<span id="errormessage" class="small">'+error+'</span>';
		

		

		var errorMSG = createErrorElement(el.id, err);
		$(el).addClass("has-error");
		
		if ($(el).parent().hasClass('input-group validation-icon')) {
			$(el).parent().addClass('has-error');
			$(el).parent().addClass('has-feedback');
			$(errorMSG).insertAfter($(el).parent());
		}else if ($(el).hasClass('dropdownselect')) {
			$(el).parent().addClass('has-error');
			$(el).parent().addClass('has-feedback');
			$(errorMSG).insertAfter($(el).next());
		}else if($(el).hasClass('uicombodate')) {
			$(errorMSG).insertAfter($(el).parent());
			$(el).parent().addClass('has-error');
			$(el).parent().addClass('has-feedback');
		} else if(el.id=="promocode") {
			errorMSG = $(errorMSG).addClass('h2 nomargin')[0];

			$(errorMSG).insertAfter($('#'+el.id).parent().parent().parent());
		} else {
			$(errorMSG).insertAfter(el);
		}
	};

	var createErrorElement = function (id, errMsg) {
		return '<div id="error' + id + '">' +
					'<p for="' + id + '" class="mt-3" role="alert">' +
						'<small>' +
							'<i aria-hidden="true" class="fa fa-warning red"></i>' +
							errMsg +
						'</small>' +
					'</p>' +
				'</div>';
	}
	
	return{
		removeError:removeError,
		showValidationSuccesIcon : showValidationSuccesIcon,
		showError : showError,
		showClientErrors : showClientErrors,
		showServerErrors: showServerErrors,
		validators :validators,
		showHeaderErrors:showHeaderErrors,
		showHeaderError:showHeaderError,
		removeHeaderErrors:removeHeaderErrors,
		isEmptyValue:isEmptyValue,
		isValidDateLabel:isValidDateLabel,
		showMessages:showMessages,
		tcIdValidator:tcIdValidator,
		validTCKNO:validTCKNO
	};

});
